var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.89 22.26a1.88 1.88 0 0 1-1.23-1.78v-6.45H9.32c-.76 0-1.42-.43-1.73-1.12-.31-.69-.19-1.47.31-2.04l7.57-8.6c.53-.6 1.35-.81 2.1-.52.75.28 1.23.98 1.23 1.78v6.45h2.34c.76 0 1.42.43 1.73 1.12.31.69.19 1.47-.31 2.04l-7.57 8.6c-.37.42-.89.64-1.42.64-.23 0-.46-.04-.68-.12zm3.7-19-7.57 8.61c-.16.18-.1.36-.07.43s.13.24.37.24h3.09c.41 0 .75.34.75.75v7.2c0 .25.18.35.26.38.08.03.28.08.44-.11l7.57-8.61c.16-.18.1-.36.07-.43a.39.39 0 0 0-.37-.24h-3.09c-.41 0-.75-.34-.75-.75v-7.2c0-.25-.18-.35-.26-.38a.306.306 0 0 0-.15-.03c-.09 0-.2.03-.29.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7zM1.5 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75h-6zM1.5 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-flash.d47af59df360215f297e478f874c3ed2.svg";
export { ForwardRef as ReactComponent };